export const runIdle = (cb: () => void): void => {
  if (!process.client || typeof window === 'undefined') {
    cb()
    return
  }

  if (typeof requestIdleCallback === 'function') {
    requestIdleCallback(cb)
    return
  }

  // Safari fallback
  window.setTimeout(cb, 100)
}
